'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colorPalette = require('../color-palette-14d554dc.js');



exports.ALOE_100 = colorPalette.ALOE_100;
exports.APRICOT_10 = colorPalette.APRICOT_10;
exports.APRICOT_100 = colorPalette.APRICOT_100;
exports.APRICOT_40 = colorPalette.APRICOT_40;
exports.APRICOT_60 = colorPalette.APRICOT_60;
exports.ATLANTIC_100 = colorPalette.ATLANTIC_100;
exports.ATLANTIC_90 = colorPalette.ATLANTIC_90;
exports.BERRY_10 = colorPalette.BERRY_10;
exports.BERRY_100 = colorPalette.BERRY_100;
exports.BERRY_20 = colorPalette.BERRY_20;
exports.CACTUS_100 = colorPalette.CACTUS_100;
exports.CACTUS_80 = colorPalette.CACTUS_80;
exports.CHARCOAL_10 = colorPalette.CHARCOAL_10;
exports.CHARCOAL_100 = colorPalette.CHARCOAL_100;
exports.CHARCOAL_20 = colorPalette.CHARCOAL_20;
exports.CHARCOAL_40 = colorPalette.CHARCOAL_40;
exports.CHARCOAL_5 = colorPalette.CHARCOAL_5;
exports.CHARCOAL_90 = colorPalette.CHARCOAL_90;
exports.FOG_10 = colorPalette.FOG_10;
exports.FOG_100 = colorPalette.FOG_100;
exports.FOG_20 = colorPalette.FOG_20;
exports.FOG_40 = colorPalette.FOG_40;
exports.FOG_60 = colorPalette.FOG_60;
exports.GRADIENT_ALOE_PINE = colorPalette.GRADIENT_ALOE_PINE;
exports.GRADIENT_MINT_CACTUS = colorPalette.GRADIENT_MINT_CACTUS;
exports.GRADIENT_WHITE_MOSS = colorPalette.GRADIENT_WHITE_MOSS;
exports.MANGO_100 = colorPalette.MANGO_100;
exports.MANGO_40 = colorPalette.MANGO_40;
exports.MANGO_60 = colorPalette.MANGO_60;
exports.MINT_100 = colorPalette.MINT_100;
exports.MINT_80 = colorPalette.MINT_80;
exports.MOSS_100 = colorPalette.MOSS_100;
exports.MOSS_50 = colorPalette.MOSS_50;
exports.MOSS_70 = colorPalette.MOSS_70;
exports.MYSTIC_100 = colorPalette.MYSTIC_100;
exports.MYSTIC_20 = colorPalette.MYSTIC_20;
exports.MYSTIC_40 = colorPalette.MYSTIC_40;
exports.MYSTIC_60 = colorPalette.MYSTIC_60;
exports.MYSTIC_80 = colorPalette.MYSTIC_80;
exports.PINE_100 = colorPalette.PINE_100;
exports.SAGE_100 = colorPalette.SAGE_100;
exports.SLATE_100 = colorPalette.SLATE_100;
exports.SLATE_50 = colorPalette.SLATE_50;
exports.WALDEN_100 = colorPalette.WALDEN_100;
exports.WHITE_10 = colorPalette.WHITE_10;
exports.WHITE_100 = colorPalette.WHITE_100;
exports.WHITE_20 = colorPalette.WHITE_20;
exports.WHITE_50 = colorPalette.WHITE_50;
exports.WHITE_60 = colorPalette.WHITE_60;
//# sourceMappingURL=index.js.map
